import { CanComponentDeactivate } from '../guards/can-close-blade.guard';
import { Observable } from 'rxjs';

export abstract class IBladeComponent implements CanComponentDeactivate {
    abstract childComponent?: IBladeComponent;
    abstract title?: string;
    abstract title$?: Observable<string|undefined>;
    abstract bladeIndex: number;
    abstract isLoading$?: Observable<boolean>;
    abstract isLoadingExtra$?: Observable<boolean>;
    abstract canDeactivate(): Observable<boolean> | Promise<boolean> | boolean;
}

// add stuff here if we want to add dynamic header for example
export interface IBladeDefinition<T> {
    name: string;
}

// decorator that adds the bladeDefintion to the component as bladeInfo
export function Blade(definition: IBladeDefinition<any>): any {
    return (target: any, propertyKey: string, descriptor: any) => {
        if (!target.bladeInfo) {
            target.bladeInfo = {};
        }
        for (const key in definition) {
            if (definition[key]) {
                target.bladeInfo[key] = definition[key];
            }
        }
        return descriptor;
    };
}
